module.exports = __webpack_public_path__ + "static/media/motor5.a6322087.jpg";